<template>
  <div>
    <div class="panel">
      <div class="dialog-group-title">选择打印模板</div>
      <el-form label-width="80px">
        <el-row>
          <el-col :span="24">
              <el-form-item label="请选择" prop="orderCode">
                <el-select
                    size="small"
                      v-model="printTemplate"
                      clearable
                      placeholder="请选择"
                      style="width:100%;"

                      @change="templateChange"

                  >
                      <el-option
                      v-for="item in printTemplateList"
                      :key="item._id"
                      :label="item.name"
                      :value="item._id"
                      ></el-option>
                  </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div class="dialog-group-title">预览</div>
        <div id="printArea" ref="printArea">
          <table style="width:100%;" align="left"  cellspacing="0" class="printTbl" v-if="type == 'task'">
          <tr>
            <td colspan="2">
              <span style="font-size: 16px;color: red;font-weight: bold;">智慧工厂——任务单</span>
            </td>
            <td rowspan="40">
              <img :src="imgBase64" />
            </td>
          </tr>
          <tr v-if="printData.orderCode">
            <td>
              <span style="font-size: 16px;color: red;">工单编号</span>
            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData.orderCode}}</span>
            </td>
          </tr>
          <tr v-if="printData.productCode">
            <td>
              <span style="font-size: 16px;color: red;">产品编号</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData.productCode}}</span>
            </td>
          </tr>
          <tr v-if="printData.productName">
            <td>
              <span style="font-size: 16px;color: red;">产品名称</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData.productName}}</span>
            </td>
          </tr>
          <tr v-if="printData.processCode">
            <td>
              <span style="font-size: 16px;color: red;">工序编号</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData.processCode}}</span>
            </td>
          </tr>
          <tr v-if="printData.processName">
            <td>
              <span style="font-size: 16px;color: red;">工序名称</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData.processName}}</span>
            </td>
          </tr>
          <tr v-if="printData.specs">
            <td>
              <span style="font-size: 16px;color: red;">产品规格</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData.specs}}</span>
            </td>
          </tr>
          <tr v-if="printData.userNameList">
            <td>
              <span style="font-size: 16px;color: red;">报工权限</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData.userNameList?printData.userNameList.join(','):""}}</span>
            </td>
          </tr>


          <tr v-if="printData.coefficient">
            <td>
              <span style="font-size: 16px;color: red;">报工数配比</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData.coefficient}}</span>
            </td>
          </tr>
          <tr v-if="printData.allocateList">
            <td>
              <span style="font-size: 16px;color: red;">分配列表</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData.allocateList?printData.allocateList.join(','):""}}</span>
            </td>
          </tr>
          <tr v-if="printData.planNum">
            <td>
              <span style="font-size: 16px;color: red;">计划数</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData.planNum}}</span>
            </td>
          </tr>
          <tr v-if="printData.goodNum">
            <td>
              <span style="font-size: 16px;color: red;">良品数</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData.goodNum}}</span>
            </td>
          </tr>
          <tr v-if="printData.nongoodNum">
            <td>
              <span style="font-size: 16px;color: red;">不良品数</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData.nongoodNum}}</span>
            </td>
          </tr>
          <tr v-if="printData.taskStatus">
            <td>
              <span style="font-size: 16px;color: red;">任务状态</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData.taskStatus}}</span>
            </td>
          </tr>
          <tr v-if="printData.planStartTime">
            <td>
              <span style="font-size: 16px;color: red;">计划开始时间</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData.planStartTime}}</span>
            </td>
          </tr>
          <tr v-if="printData.planEndTime">
            <td>
              <span style="font-size: 16px;color: red;">计划结束时间</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData.planEndTime}}</span>
            </td>
          </tr>
          <tr v-if="printData.actualStartTime">
            <td>
              <span style="font-size: 16px;color: red;">实际开始时间</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData.actualStartTime}}</span>
            </td>
          </tr>
          <tr v-if="printData.actualEndTime">
            <td>
              <span style="font-size: 16px;color: red;">实际结束时间</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData.actualEndTime}}</span>
            </td>
          </tr>
          <tr v-if="printData.creater">
            <td>
              <span style="font-size: 16px;color: red;">创建人</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData.creater}}</span>
            </td>
          </tr>
          <tr v-if="printData.createTime">
            <td>
              <span style="font-size: 16px;color: red;">创建时间</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData.createTime}}</span>
            </td>
          </tr>
          <tr v-if="printData.updateTime">
            <td>
              <span style="font-size: 16px;color: red;">更新时间</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData.updateTime}}</span>
            </td>
          </tr>

          </table>

          <table style="width:100%;" align="left"  cellspacing="0" class="printTbl" v-if="type == 'enter'">
          <tr>
            <td colspan="2">
              <span style="font-size: 16px;color: red;font-weight: bold;">智慧工厂——任务单</span>
            </td>
            <td rowspan="12">
              <img :src="imgBase64" />
            </td>
          </tr>
          <tr v-if="printData['baseInfo.orderCode']">
            <td>
              <span style="font-size: 16px;color: red;">工单编号</span>
            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['baseInfo.orderCode']}}</span>
            </td>
          </tr>
          <tr v-if="printData['baseInfo.productCode']">
            <td>
              <span style="font-size: 16px;color: red;">产品编号</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['baseInfo.productCode']}}</span>
            </td>
          </tr>
          <tr v-if="printData['baseInfo.productName']">
            <td>
              <span style="font-size: 16px;color: red;">产品名称</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['baseInfo.productName']}}</span>
            </td>
          </tr>
          <tr v-if="printData['baseInfo.processCode']">
            <td>
              <span style="font-size: 16px;color: red;">工序编号</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['baseInfo.processCode']}}</span>
            </td>
          </tr>
          <tr v-if="printData['baseInfo.processName']">
            <td>
              <span style="font-size: 16px;color: red;">工序名称</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['baseInfo.processName']}}</span>
            </td>
          </tr>
          <tr v-if="printData['baseInfo.specs']">
            <td>
              <span style="font-size: 16px;color: red;">产品规格</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['baseInfo.specs']}}</span>
            </td>
          </tr>
          <tr v-if="printData['baseInfo.countNum']">
            <td>
              <span style="font-size: 16px;color: red;">报工数量</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['baseInfo.countNum']}}</span>
            </td>
          </tr>


          <tr v-if="printData['performanceInfo.countType']">
            <td>
              <span style="font-size: 16px;color: red;">计价方式</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['performanceInfo.countType']}}</span>
            </td>
          </tr>
          <tr v-if="printData['performanceInfo.salaryUnit']">
            <td>
              <span style="font-size: 16px;color: red;">工资单价</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['performanceInfo.salaryUnit']}}</span>
            </td>
          </tr>
          <tr v-if="printData['performanceInfo.estimateSalary']">
            <td>
              <span style="font-size: 16px;color: red;">预计工资</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['performanceInfo.estimateSalary']}}</span>
            </td>
          </tr>
          <tr v-if="printData['baseInfo.goodNum']">
            <td>
              <span style="font-size: 16px;color: red;">良品数</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['baseInfo.goodNum']}}</span>
            </td>
          </tr>
          <tr v-if="printData['baseInfo.nongoodNum']">
            <td>
              <span style="font-size: 16px;color: red;">不良品数</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['baseInfo.nongoodNum']}}</span>
            </td>
          </tr>
          <tr v-if="printData['baseInfo.unit']">
            <td>
              <span style="font-size: 16px;color: red;">单位</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['baseInfo.unit']}}</span>
            </td>
          </tr>
          <tr v-if="printData['baseInfo.producer.name']">
            <td>
              <span style="font-size: 16px;color: red;">生产人员</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['baseInfo.producer.name']}}</span>
            </td>
          </tr>
          <tr v-if="printData['baseInfo.timeRange']">
            <td>
              <span style="font-size: 16px;color: red;">报工时间</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['baseInfo.timeRange']?printData['baseInfo.timeRange'].join('~'):''}}</span>
            </td>
          </tr>

          <tr v-if="printData.creater">
            <td>
              <span style="font-size: 16px;color: red;">创建人</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData.creater}}</span>
            </td>
          </tr>
          <tr v-if="printData.createTime">
            <td>
              <span style="font-size: 16px;color: red;">创建时间</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData.createTime}}</span>
            </td>
          </tr>
          <tr v-if="printData.updator">
            <td>
              <span style="font-size: 16px;color: red;">更新人</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData.updator}}</span>
            </td>
          </tr>
          <tr v-if="printData.updateTime">
            <td>
              <span style="font-size: 16px;color: red;">更新时间</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData.updateTime}}</span>
            </td>
          </tr>

          </table>
        </div>
        <!-- <el-table :data="channelForm.selectedChannelList" style="width: 100%">
            <el-table-column type="index" label="序号">
            </el-table-column>
            <el-table-column prop="text" label="名称">
            </el-table-column>
            <el-table-column
            label="操作"
            fixed="right"
            width="100">
            <template slot-scope ="scope">
              <el-button @click.native.prevent="deleteRow(scope.$index, scope.row, 'up')" type="text" size="small"> 上移</el-button>
              <el-button @click.native.prevent="deleteRow(scope.$index, scope.row, 'down')" type="text" size="small">下移</el-button>
            </template>
            </el-table-column>
        </el-table> -->

        <!-- <div>
          <img :src="imgBase64" />
        </div> -->





    </div>
    <div class="panel-bottom">
         <el-button size="small" type="default"  @click="closeDialog">关闭</el-button>
         <el-button size="small" type="primary"  v-print="'#printArea'" >打印</el-button>
     </div>
  </div>
  </template>
  <script>
 import { queryPrintTemplateAll,printPreview,savePrintTemplate} from '@/api/business';


  export default {
   name:'PrintLayout',

   props:{
       userData:{
         type:Object,
         default:{},
       },

       editRow:{
           type:Object,

           default:{}
       },
       userList:{
          type:Array,

          default:[]
       },
       type:{
        type:String,
        default:''
       }


   },
   watch:{


       editRow:{
          handler(newVal) {

              if(newVal){
                  this.form = JSON.parse(JSON.stringify(newVal));

              }
          },
          deep: true,
          immediate: true
        }
   },
   data(){
       return{
        printTemplateList:[],
        printTemplate:'',
        form:{},
        channelForm:{
          selectedChannelList:[
            {text:'123'},
            {text:'456'},
            {text:'789'},
          ],
          selectedChannelListindex:[],
        },
        imgBase64:'',
        printData:[],


       }
   },
   created(){
    if(this.userData){
      this.form.factoryId = this.userData.factoryId;
      this.init();

    }
   },
   methods:{
    templateChange(val){
      printPreview(this.form._id,val).then(res=>{
        if(res.code==200){
          this.imgBase64 = 'data:image/png;base64,'+ res.data.base64;
          this.printData = res.data.content;
        }
      })
    },
    init(){
      queryPrintTemplateAll(this.userData.factoryId,this.type).then(res=>{
        if(res.code == 200){
          this.printTemplateList = res['data'];
          if(res["data"] && res['data'].length > 0){

            this.printTemplate = res['data'][0]._id;
          }else{
            return;
          }

          printPreview(this.form._id,this.printTemplate).then(res=>{
            if(res.code==200){
              this.imgBase64 = 'data:image/png;base64,'+ res.data.base64;
              this.printData = res.data.content;

            }
          })
        }
      });
    },
    deleteRow (index, e, type) {
        if (type === 'up') {
          if (index === 0){

            return;
          }
          //在上一项插入该项
          this.channelForm.selectedChannelList.splice(index - 1, 0, (this.channelForm.selectedChannelList[index]));// 删除后一项
          this.channelForm.selectedChannelList.splice(index + 1, 1);
        } else if (type === 'down') {
          if (index === (this.channelForm.selectedChannelList.length - 1)){

            return;
          }
          this.channelForm.selectedChannelList.splice(index + 2,0,(this.channelForm.selectedChannelList[index]));
          this.channelForm.selectedChannelList.splice(index,1);
        }
    },

    handlePrint(){
      var oldHtml = window.document.body.innerHTML;
      var newHtml = window.document.getElementById('printArea').innerHTML;
      window.document.body.innerHTML = newHtml;
      window.print();
      window.document.body.innerHTML = oldHtml;

    },

    closeDialog(){
      this.$emit('done',{type:'cancel'})
    },
   }

  }
  </script>
  <style>
   .panel{
       overflow-y: auto;
       overflow-x: hidden;
   }

   .panel-bottom{
       width: 100%;
       height: 40px;
       line-height: 40px;
       padding-top: 20px;
       text-align: center;
   }
   .panel-bottom el-button{
       margin: 10px 0 0 10px;
   }
   .printTbl {
        border-right: 1px solid #000000;
        border-bottom: 1px solid #000000;
        text-align: center;
    }

    .printTbl th {
        border-left: 1px solid #000000;
        border-top: 1px solid #000000;
    }

    .printTbl td {
        border-left: 1px solid #000000;
        border-top: 1px solid #000000;
    }
  </style>



// WEBPACK FOOTER //
// src/views/task/PrintLayout.vue